import React from 'react'
import UnitsLayout from '../../../assets/unitsLayout.png'
import {
  StorageLayoutEntranceTag,
  StorageLayoutEyebrow,
  StorageLayoutGraphicShell,
  StorageLayoutGridOverlay,
  StorageLayoutHeader,
  StorageLayoutHeaderContent,
  StorageLayoutImage,
  StorageLayoutLegend,
  StorageLayoutLegendItem,
  StorageLayoutLegendSwatch,
  StorageLayoutRoot,
  StorageLayoutTitle,
} from './styled'

const LAYOUT_LEGEND = [
  {
    label: 'Climate Controlled',
    color: 'linear-gradient(180deg, #2f8cff 0%, #1a69f2 100%)',
  },
  {
    label: 'Non Climate',
    color: 'linear-gradient(180deg, #b9bcc3 0%, #8e939e 100%)',
  },
  {
    label: 'Boat/RV Storage',
    color: 'linear-gradient(180deg, #d8dc31 0%, #acb10d 100%)',
  },
]

export const StorageLayoutGraphic: React.FC<{
  immersive?: boolean
}> = ({ immersive = false }) => (
  <StorageLayoutRoot className="storage-layout" immersive={immersive}>
    <StorageLayoutHeader
      className="storage-layout__header"
      immersive={immersive}
    >
      <StorageLayoutHeaderContent className="storage-layout__header-content">
        <StorageLayoutEyebrow className="storage-layout__eyebrow">
          Property Overview
        </StorageLayoutEyebrow>
        <StorageLayoutTitle
          className="storage-layout__title"
          immersive={immersive}
        >
          See the full site layout before booking so you can compare drive-up
          access, climate-controlled buildings, and covered vehicle spaces.
        </StorageLayoutTitle>
      </StorageLayoutHeaderContent>

      <StorageLayoutLegend className="storage-layout__legend">
        {LAYOUT_LEGEND.map(({ label, color }) => (
          <StorageLayoutLegendItem
            key={label}
            className="storage-layout__legend-item"
          >
            <StorageLayoutLegendSwatch
              className="storage-layout__legend-swatch"
              swatchcolor={color}
            />
            {label}
          </StorageLayoutLegendItem>
        ))}
      </StorageLayoutLegend>
    </StorageLayoutHeader>

    <StorageLayoutGraphicShell
      className="storage-layout__graphic-shell"
      immersive={immersive}
    >
      <StorageLayoutGridOverlay
        className="storage-layout__graphic-grid"
        immersive={immersive}
      />
      <StorageLayoutImage
        className="storage-layout__image"
        src={UnitsLayout}
        alt="Just Lock It storage layout"
        immersive={immersive}
      />
      <StorageLayoutEntranceTag
        className="storage-layout__entrance-tag"
        immersive={immersive}
      >
        Front Entrance
      </StorageLayoutEntranceTag>
    </StorageLayoutGraphicShell>
  </StorageLayoutRoot>
)
